<div mat-dialog-content>
    <div class="processing-spinner">
        <mat-spinner [diameter]="130" [strokeWidth]="11"></mat-spinner>
    </div>
    <div class="processing-header">Processing transaction</div>
    <div class="processing-text">
        The credit card is currently processing. Please do not close/reload this
        window.
    </div>
</div>
